import React, { useState, useEffect } from 'react'
import { logoEli } from "../../assets"
import axios from '../../lib/axios'
import errorHandler from '../../helpers/errorHandler';
import { MySwal } from '../../lib/swal'
import { isStrongPassword, PASSWORD_RULE_TEXT } from '../../helpers/passwordPolicy'
import {
    useParams
} from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const ForgotPasswordPage = () => {

    const location = useLocation();

    const params = useParams()
    const [user, setUser] = useState({})
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const handleResetPassword = () => {
        // alert('masuk')
        if (!isStrongPassword(newPassword)) {
            MySwal.fire({
                icon: 'warning',
                title: 'Oops, Password terlalu lemah!',
                text: `Password harus ${PASSWORD_RULE_TEXT}`
            })
        } else if (newPassword === confirmPassword) {
            const requestBody = {
                newPassword: newPassword,
                id: user.id,
            }

            // console.log(requestBody)
            // return false

            axios({
                url: '/users/users/reset-password',
                method: 'POST',
                data: requestBody,
                headers: {
                    Authorization: `Bearer ${params?.token}`,
                }
            })
                .then(res => {
                    // console.log(res.data.code)
                    if (res.data.code === "201") {
                        MySwal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Password berhasil di atur ulang, Silahkan login kembali!'
                        })

                        setTimeout(() => {
                            window.location.href = "/login"
                        }, 3000);

                    }
                })
                .catch(err => {
                    if (err !== "") {
                        console.log(err)
                        errorHandler({ err: err?.response?.data || err })
                    }
                })
        } else {
            MySwal.fire({
                icon: 'error',
                title: 'Gagal',
                text: 'Konfirmasi password gagal!'
            })
        }

    }

    const fetchUserByToken = async () => {
        try {
            const options = {
                url: `/users/users/`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${params?.token}`,
                }
            }
            const { data } = await axios(options)
            // console.log(data.data)
            setUser(data.data)
        } catch (err) {
            errorHandler({ err: err?.response?.data || err })
        }
    }

    useEffect(() => {
        fetchUserByToken()
    }, [])

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: {
            url: window.location.pathname + window.location.search,
            title: document.title
            }
        });
    }, [location]);

    return (
        <>
            <div className='container' style={{ marginTop: '10%' }}>
                <div className='row'>
                    <div className='col-6' style={{ margin: 'auto' }}>
                        <div className="card">
                            <img src={logoEli} alt="logoEli" style={{ margin: 'auto' }} />
                            <div className="card-body">
                                <h1 className="card-title mb-3" style={{ fontSize: '20px' }}>Reset Password</h1>
                                <div className="mb-3">
                                    <label htmlFor="new-password" className="form-label">New Password</label>
                                    <input type="password" className="form-control" id="new-password" placeholder="******" onChange={(e) => setNewPassword(e.target.value)} value={newPassword}
                                        style={{ borderColor: (newPassword.length > 0 && !isStrongPassword(newPassword)) ? '#F1416C' : '' }} />
                                    <p className='mt-2 mb-0' style={{ fontSize: '12px', color: (newPassword.length > 0 && !isStrongPassword(newPassword)) ? '#F1416C' : '' }}>{PASSWORD_RULE_TEXT}</p>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="confirm-password" className="form-label">Confirm Password</label>
                                    <input type="password" className="form-control" id="confirm-password" placeholder="******" onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} />
                                </div>
                                <button class="btn" style={{ marginRight: '10px', backgroundColor: '#26D07C', color: '#F2F2F2' }} onClick={() => handleResetPassword()}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPasswordPage
